import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

const Note = ({ values, setFieldValue }) => {
  const { t } = useTranslation(['visitors'])
  return (
    <div className="columns visitorMarginTop">
      <div className="column is-12">
        <div className="input-container">
          <div className="note-container">
            <div className="visitor-checkbox-container">
              <input
                type="checkbox"
                id="addNoteCheckbox"
                className="visitorsCheckbox"
                checked={values.isVisitorNoteOpen}
                onChange={(e) => setFieldValue('isVisitorNoteOpen', e.target.checked)}
              />
              <label htmlFor="addNoteCheckbox" className="visitorCheckBoxLabel">
                {t('visitors:form.addNote')}
              </label>
            </div>
            {values.isVisitorNoteOpen && (
              <textarea
                maxLength={200}
                id="visitorNote"
                className="visitor-text-input"
                placeholder={t('visitors:form.notePlaceholder')}
                value={values.visitorNote}
                onChange={(e) => setFieldValue('visitorNote', e.target.value)}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

Note.propTypes = {
  values: PropTypes.object.isRequired,
  setFieldValue: PropTypes.func.isRequired,
}

export default Note
